import { FlowRunDetail as FlowRunDetailModel } from "@/models/flows";
import { Trigger } from "./Trigger";
import { StepRun } from "./StepRun";
import { OctagonXIcon, PauseCircleIcon } from "lucide-react";

interface Props {
  flowRun: FlowRunDetailModel;
  // for auto expanding form inputs in triggers
  expandTriggerInput?: boolean;
}

export const FlowRunDetail = ({ flowRun, expandTriggerInput }: Props) => {
  return (
    <div>
      <Trigger flowRun={flowRun} expandTriggerInput={expandTriggerInput} />
      {flowRun.stepRuns.map((stepRun, index) => (
        <div className="mt-4" key={stepRun.id}>
          <StepRun
            stepRun={stepRun}
            nextStepRun={
              index <= flowRun.stepRuns.length
                ? flowRun.stepRuns[index + 1]
                : undefined
            }
          />
        </div>
      ))}
      {flowRun.finishedAt && (
        <div className="flex ml-2 mt-4">
          <div
            className={`bg-red-500 inline-flex p-1 rounded-md relative z-10`}
          >
            <OctagonXIcon className="h-5 w-5 text-white" />
          </div>
          <div className="flex items-center justify-between w-full ml-2 text-sm">
            <h2 className="dark:text-white font-medium">End of flow</h2>
          </div>
        </div>
      )}
      {flowRun.status === "waiting" && (
        <div className="flex ml-2 mt-4">
          <div
            className={`bg-gray-500 inline-flex p-1 rounded-md relative z-10`}
          >
            <PauseCircleIcon className="h-5 w-5 text-white" />
          </div>
          <div className="flex items-center justify-between w-full ml-2 text-sm">
            <h2 className="dark:text-white font-medium">Waiting</h2>
          </div>
        </div>
      )}
    </div>
  );
};
